import { ModuleWithProviders, NgModule } from '@angular/core';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';

import { AuthModule } from 'src/app/auth/auth.module';
import { SharedModule } from 'src/app/shared.module';
import { ViewsModule } from '../../views/views.module';
import { EventMessengerModule } from '../event-messenger/event-messenger.module';
import { EventNotificationsModule } from '../event-notifications/event-notifications.module';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';

@NgModule({
  imports: [SharedModule, NgbCollapseModule, AuthModule, EventMessengerModule, EventNotificationsModule, ViewsModule],
  exports: [HeaderComponent, FooterComponent],
  declarations: [HeaderComponent, FooterComponent],
})
export class NavigationModule {
  public static forRoot(): ModuleWithProviders<NavigationModule> {
    return {
      ngModule: NavigationModule,
    };
  }
}
